const { runAttributesValidation } = require('./validations');

const { AttributeValidationError } = require('./validation-errors');
const { IllegalArgumentError } = require('../errors');

const AttributeValidator = (attributes) => {
  try {
    runAttributesValidation(attributes);
  } catch (err) {
    if (err instanceof AttributeValidationError) {
      throw new IllegalArgumentError(err.message);
    } else {
      throw err;
    }
  }
};

module.exports = {
  AttributeValidator,
};
